import React, { Component } from 'react'
import { connect } from 'react-redux'
import {AvailableActions} from '../../redux/actions/dataQuery'
import DatePicker from 'antd/lib/date-picker'
import Icon from 'antd/lib/icon'
import Button from 'antd/lib/button'
import moment from 'moment'

import s from './style.scss'

class DateRangeInput extends Component {

    dateFormat = 'YYYY-MM-DD'

    getPresets = () => {

        let ranges = {
            'This month': [moment().startOf('month'), moment()],
            'Last month': [moment().startOf('month').subtract(1, 'month'),
                moment().endOf('month').subtract(1, 'month')],
            'This year': [moment().startOf('year'), moment()]
        }

        for(let i = 0; i <= 5; i++) {

            let description = moment().startOf('year').subtract(i+1, 'year').format('YYYY')
            let start = moment().startOf('year').subtract(i+1, 'year')
            let end = moment().startOf('year').subtract(i, 'year').subtract(1, 'day')

            ranges[description] = [start, end]
        }
        
        return ranges
    }
    
    addField = () => {
        let dateRanges = this.props.store.dateRanges.slice()
        dateRanges.push([])
        this.props.setDataQuery({dateRanges})
    }

    removeField = i => {
        let dateRanges = this.props.store.dateRanges.slice()
        dateRanges.splice(i,1)
        this.props.setDataQuery({dateRanges})

        // workaround to correct wrong initial values
        dateRanges.forEach((dateRange, i) => {
            this.props.antForm.setFieldsValue({
                [`dateRanges[${i}]`]: this.dateStringsToMoment(dateRange)
            })
        })

    }

    updateField = (values, i) => {
        let dateRanges = this.props.store.dateRanges.slice()
        dateRanges[i] = values
        this.props.setDataQuery({dateRanges})
    }

    dateStringsToMoment = dateStrings => 
        dateStrings.length === 2
            ? [moment(dateStrings[0], this.dateFormat),
                moment(dateStrings[1], this.dateFormat)]
            : null

    render() {
        return(
            <React.Fragment>
                { this.props.store.dateRanges.map((dateRange, i) =>
                    <div className={s.dateField} key={i + Date.now()}>
                        { this.props.store.dateRanges.length > 1 &&
                            <Icon
                                className={s.removeIcon}
                                key={i}
                                type="minus-circle-o"
                                onClick={ () => { this.removeField(i) } }
                            />
                        }
                        {this.props.antForm.getFieldDecorator(`dateRanges[${i}]`, {
                            initialValue: this.dateStringsToMoment(dateRange),
                            onChange: (fields, values) => {
                                this.updateField(values, i)
                            }
                        })(
                            <DatePicker.RangePicker
                                key={i + Date.now()}
                                format={this.dateFormat}
                                allowClear={false}
                                ranges={this.getPresets()}
                            />
                        )}
                        <br />
                    </div>
                )}

                <Button
                    className={s.addButton}
                    icon="plus-circle-o"
                    onClick={this.addField.bind(this)}
                >Add date range</Button>

            </React.Fragment>
        )
    }

}

const mapStateToProps = state => {
    return {
        store: state.dataQuery,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setDataQuery: (dataQuery) => dispatch({
            type: AvailableActions.SET_DATA_QUERY,
            payload: dataQuery
        })
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(DateRangeInput)